import { render, staticRenderFns } from "./FormStatusHistory.modal.vue?vue&type=template&id=0adae868&"
import script from "./FormStatusHistory.modal.vue?vue&type=script&lang=ts&"
export * from "./FormStatusHistory.modal.vue?vue&type=script&lang=ts&"
import style0 from "./FormStatusHistory.modal.vue?vue&type=style&index=0&id=0adae868&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports